import classes from "./styles/style.module.css";
import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";
import StorefrontIcon from "@material-ui/icons/Storefront";
import CustomButton from "../../assets/components/CustomButton";
import { useNavigate } from "react-router-dom";

const ContractingStores = () => {
  const navigate = useNavigate();

  return (
    <AnimatedPageContainer>
      <div className="customContainer">
        <div className="w-100 d-flex justify-content-center pt-5 pb-3">
          <StorefrontIcon style={{ color: "#FF9B14", fontSize: "50px" }} />
        </div>
        <p className={classes.title}>مراکز طرف قرارداد</p>
        <p className={classes.formSubtitle}>
          مراکز تفریحی و کتاب فروشی های طرف قرارداد
        </p>
        <img
          src={`https://api.v2.rahebehesht.com/file/get/cover_contract_1789761150.png`}
          //   crossOrigin="anonymous"
          alt="poster"
          className="w-100 img-fluid my-4 borderRadius"
        />
        <div className={classes.formDesc}>
          فهرست مراکز فرهنگی تفریحی طرف قــرارداد شرکت فولاد مبارکه اصفــهان
          «سال ۱۴۰۵»
          <br />
          <br />
          🔶شما عزیزان می توانید برای استفاده از این مراکز تفریحی🏞
          <br />
          <br />
          📌 با ارائه کارت پرسنلی، از تخفیفات ویژه این مراکز به همراه خانواده ی
          گرانقدر خود برای سپری کردن اوقاتی خوش استفاده کنید.✌️😎
          <br />
          <br />
          ✔️مدیریت ارتباطات گروه فولاد مبارکه
        </div>
        <CustomButton
          text={"فهرست مراکز تفریحی طرف قرارداد"}
          color={"primary"}
          clickHandler={() => {
            navigate(
              "/pdf/فهرست مراکز فرهنگی تفریحی طرف قرارداد ۱۴۰۵_1789761347.pdf"
            );
          }}
          styles={{ marginTop: "30px" }}
        />
        <CustomButton
          text={"فهرست مراکز فرهنگی کتاب فروشی طرف قرارداد"}
          color={"primary"}
          clickHandler={() => {
            navigate(
              "/pdf/فهرست مراکز کتاب فروشی طرف قرارداد ۱۴۰۵_1789761478.pdf"
            );
          }}
          styles={{ marginBlock: "30px" }}
        />
      </div>
    </AnimatedPageContainer>
  );
};

export default ContractingStores;
